import { convertMenu2Item, convertProduct2Item } from '../index'

export const getConvertedProduct2Item = ({ product, quantity, price, priceIndex, items, priceTitle, priceTitleId, module }) => {
	const productItem = convertProduct2Item(product, quantity, price, priceIndex, items, priceTitle)
	if (module === 'CASH_DESK') {
		return {
			...productItem,
			initialProduct: product,
			priceTitleId: priceTitleId ? priceTitleId : ''
		}
	}
	if (module === 'DELIVERY') {
		return {
			...productItem,
			priceTitleId: priceTitleId ? priceTitleId : ''
		}
	}
	return productItem
}

export const getConvertedMenu2Item = ({ menu, quantity, price, module }) => {
	const menuItem = convertMenu2Item(menu, quantity, price)
	if (module === 'CASH_DESK') {
		return {
			...menuItem,
			initialProduct: menu,
			priceTitleId: ''
		}
	} else {
		return menuItem
	}
}
